<template>
  <collection
    name="payment"
    :loading="loading"
    :options="options"
    :data="getAllPayments"
    :columns="1"
  >
    <template v-slot:action>
      <span class="g-flex buttons">
        <button
          class="g-button is-light"
          @click="download">Download</button>
        <router-link
          class="g-button"
          :to="{ name: 'NewPayment' }">New
        </router-link>
      </span>
    </template>
    <template v-slot:item="slotProps">
      <payment-preview v-bind="slotProps.record" />
    </template>
  </collection>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters, mapActions } from 'vuex';
import searchConfig from '@/utilities/searchConfig';
import downloadCsv from '@/utilities/downloadCsv';
import { TEXTDATEFORMAT, FULLTIMEFORMAT } from '@/utilities/time';
import Collection from '@/components/Collection.vue';
import PaymentPreview from './PaymentPreview.vue';

export default {
  name: 'ListStrips',
  components: {
    Collection,
    PaymentPreview,
  },
  data() {
    return {
      loading: true,
      options: {
        search: {
          ...searchConfig,
          keys: ['name', 'email', 'startsAt', 'endsAt'],
        },
      },
    };
  },
  computed: {
    ...mapGetters(['getAllPayments']),
    csvData() {
      return this.getAllPayments.map((payment, index) => ({
        id: this.getAllPayments.length - index,
        email: payment.email,
        currency: payment.currency,
        amount: payment.amount / 100,
        date: dayjs.unix(payment.createdAt.seconds).format(TEXTDATEFORMAT),
        processor: payment.processor,
        discount: payment.discount ? payment.discount : '-',
        season: payment.season,
      }));
    },
  },
  methods: {
    ...mapActions(['fetch']),
    download() {
      downloadCsv({
        csvTitle: `JAND_Payments_${dayjs().format(FULLTIMEFORMAT)}`,
        jsonData: this.csvData,
        showLabels: true,
      });
    },
  },
  mounted() {
    this.fetch({ model: 'payments' }).finally(() => {
      this.loading = false;
    });
  },
};
</script>

<style lang="scss" scoped>
.buttons {
  > * + * {
    margin-left: 10px;
  }
}
</style>
